module.exports = __webpack_public_path__ + "static/img/company1.8595382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company1.png
// module id = FWd6
// module chunks = 8